var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "pending-popup-dialog",
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("kyc.pending_popup_title"),
        width: "980px",
        "close-on-click-modal": false,
        "show-close": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _vm.kycStatus === 4
        ? _c("div", [
            _c(
              "div",
              { staticClass: "pending-tip" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "warning",
                    "class-name": "pending-tip-icon",
                  },
                }),
                _c("div", { staticClass: "pending-tip-text" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.pending_rejected_tip"))),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "pending-table" }, [
              _c("div", { staticClass: "pending-table-header" }, [
                _c("div", { staticClass: "col col-business" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.pending_business_type"))),
                ]),
                _c("div", { staticClass: "col col-todo" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.pending_todo"))),
                ]),
                _c("div", { staticClass: "col col-op" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.pending_operation"))),
                ]),
              ]),
              _c("div", { staticClass: "pending-table-row" }, [
                _c("div", { staticClass: "col col-business" }, [
                  _c("div", { staticClass: "business-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("kyc.pending_business_account_verification")
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "col col-todo" }, [
                  _c("div", { staticClass: "todo-intro" }, [
                    _vm._v(_vm._s(_vm.$t("kyc.pending_rejected_message"))),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "col col-op" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setup-now",
                        attrs: { type: "primary" },
                        on: { click: _vm.onSetupNow },
                      },
                      [_vm._v(_vm._s(_vm.$t("kyc.pending_setup_now")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm.kycStatus === 1
        ? _c("div", [
            _c(
              "div",
              { staticClass: "pending-tip" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-class": "warning",
                    "class-name": "pending-tip-icon",
                  },
                }),
                _c("div", { staticClass: "pending-tip-text" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.pending_popup_tip"))),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "pending-table" }, [
              _c("div", { staticClass: "pending-table-header" }, [
                _c("div", { staticClass: "col col-business" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.pending_business_type"))),
                ]),
                _c("div", { staticClass: "col col-todo" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.pending_todo"))),
                ]),
                _c("div", { staticClass: "col col-op" }, [
                  _vm._v(_vm._s(_vm.$t("kyc.pending_operation"))),
                ]),
              ]),
              _c("div", { staticClass: "pending-table-row" }, [
                _c("div", { staticClass: "col col-business" }, [
                  _c("div", { staticClass: "business-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("kyc.pending_business_account_verification")
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "col col-todo" }, [
                  _c("div", { staticClass: "todo-intro" }, [
                    _vm._v(_vm._s(_vm.$t("kyc.pending_todo_intro"))),
                  ]),
                  _c("div", { staticClass: "todo-list" }, [
                    _c("div", [
                      _vm._v("i. " + _vm._s(_vm.$t("kyc.pending_item_1"))),
                    ]),
                    _c("div", [
                      _vm._v("ii. " + _vm._s(_vm.$t("kyc.pending_item_2"))),
                    ]),
                    _c("div", [
                      _vm._v("iii. " + _vm._s(_vm.$t("kyc.pending_item_3"))),
                    ]),
                    _c("div", [
                      _vm._v("iv. " + _vm._s(_vm.$t("kyc.pending_item_4"))),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "col col-op" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setup-now",
                        attrs: { type: "primary" },
                        on: { click: _vm.onSetupNow },
                      },
                      [_vm._v(_vm._s(_vm.$t("kyc.pending_setup_now")))]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }